/* =========================================================
   VS OUR JOURNEY
   ========================================================= */

(function () {

  'use strict';


  function initVSOurJourney(section) {

    if (!section) {
      return;
    }


    const items = section.querySelectorAll(
      '.vs-oj__item'
    );


    if (!items.length) {
      return;
    }


    /*
     * Intersection Observer
     */

    if ('IntersectionObserver' in window) {

      const observer =
        new IntersectionObserver(

          function (entries, observerInstance) {

            entries.forEach(
              function (entry) {

                if (!entry.isIntersecting) {
                  return;
                }


                const item =
                  entry.target;


                const itemIndex =
                  Array.prototype.indexOf.call(
                    items,
                    item
                  );


                const delay =
                  Math.min(
                    itemIndex * 90,
                    450
                  );


                item.style.transitionDelay =
                  delay + 'ms';


                item.classList.add(
                  'vs-oj--visible'
                );


                observerInstance.unobserve(
                  item
                );

              }
            );

          },

          {
            threshold: 0.12
          }

        );


      items.forEach(
        function (item) {

          observer.observe(item);

        }
      );

    } else {

      items.forEach(
        function (item) {

          item.classList.add(
            'vs-oj--visible'
          );

        }
      );

    }

  }


  /*
   * Initialize all sections
   */

  function initAllVSOurJourney() {

    const sections =
      document.querySelectorAll(
        '.vs-our-journey'
      );


    sections.forEach(
      function (section) {

        initVSOurJourney(section);

      }
    );

  }


  /*
   * Normal page load
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllVSOurJourney
    );

  } else {

    initAllVSOurJourney();

  }


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.vs-our-journey'
        );


      if (section) {

        initVSOurJourney(
          section
        );

      }

    }
  );


})();